import axios from 'axios/index';

// mockup
// import ReturnFakeMemberAPI from '@/store/mockup/ReturnFakeMemberAPI';
const messageTypes = ['success', 'warning', 'info', 'error'];
const messageMethod = ['toast', 'alert', 'confirm', 'notification'];

const getLoginUserAIP = (store, state, url, params) => {
  // console.log('getLoginUserAIP (connector) ========= ', url, params);
  axios
    .get(url, {
      params,
    })
    .then((res) => {
      store.commit('INITIALIZE_USER', res);
    })
    .catch((err) => {
      const alarm = {
        method: messageMethod[3],
        title: 'Notification',
        message: '서버와의 통신 이상으로 로그인 정보를 가져오지 못하였습니다.',
        text: 'notification',
        type: messageTypes[3],
        params: JSON.stringify(params),
        function: 'getLoginUserAIP',
        content: err,
      };
      store.dispatch('SET_SLACK_ALARM', alarm);
    });
};

const getConfigAPI = (store, state, url, params) => {
  // console.log('getConfigAPI (connector) =========================== ', url, params);
  store.commit('SET_LOADING', true);
  axios
    .get(url, {
      params,
    })
    .then((res) => {
      const payload = res.data.data;

      if (payload) {
        store.commit('SET_CONFIG_DATA', payload);
      } else {
        alert('잘못됨');
      }
    })
    .catch((err) => {
      const alarm = {
        method: messageMethod[3],
        title: 'Notification',
        message: '서버와의 통신 이상으로 로그인 정보를 가져오지 못하였습니다.',
        text: 'notification',
        type: messageTypes[3],
        params: JSON.stringify(params),
        function: 'getConfigAPI',
        content: err,
      };
      store.commit('SET_MESSAGE', alarm);
      store.dispatch('SET_SLACK_ALARM', alarm);
    })
    .finally(() => {
      store.commit('SET_LOADING', false);
    });
};

const getMemberAPI = (store, state, url, params) => {
  // console.log('getMemberAPI (connector) ========= ', url, params);
  store.commit('SET_LOADING', true);
  axios
    .get(url, {
      params,
    })
    .then((res) => {
      const payload = res.data.data;

      if (payload) {
        store.commit('SET_SELECTED_MEMBER_DATA', payload);
      } else {
        alert('사람 잘못됨');
      }
    })
    .catch((err) => {
      const alarm = {
        method: messageMethod[3],
        title: 'Notification',
        message: '서버와의 통신 이상으로 사용자 정보를 가져오지 못하였습니다.',
        text: 'notification',
        type: messageTypes[3],
        params: JSON.stringify(params),
        function: 'getMemberAPI',
        content: err,
      };
      store.commit('SET_MESSAGE', alarm);
      store.dispatch('SET_SLACK_ALARM', alarm);
    })
    .finally(() => {
      store.commit('SET_LOADING', false);
    });
};

const getMembersWithAuthorityAPI = (store, state, url, params) => {
  console.log('getMembersWithAuthorityAPI (connector) ========= ', url, params);
  store.commit('SET_LOADING', true);
  axios
    .get(url, {
      params,
    })
    .then((res) => {
      const payload = res.data.data;

      if (payload) {
        console.log('통신 성공 = ', payload);
        store.commit('SET_MEMBERS_WITH_AUTHORITY_DATA', payload);
      } else {
        alert('사람 잘못됨');
      }
    })
    .catch((err) => {
      const alarm = {
        method: messageMethod[3],
        title: 'Notification',
        message: '서버와의 통신 이상으로 사용자 정보를 가져오지 못하였습니다.',
        text: 'notification',
        type: messageTypes[3],
        params: JSON.stringify(params),
        function: 'getMemberAPI',
        content: err,
      };
      store.commit('SET_MESSAGE', alarm);
      store.dispatch('SET_SLACK_ALARM', alarm);
    })
    .finally(() => {
      store.commit('SET_LOADING', false);
    });
};

const getLogOfMemberWithAuthorityAPI = (store, state, url, params) => {
  console.log('getLogOfMemberWithAuthorityAPI (connector) ========= ', url, params);
  store.commit('SET_LOADING', true);
  axios
    .get(url, {
      params,
    })
    .then((res) => {
      const payload = res.data.data;

      if (payload) {
        console.log('통신 성공 = ', payload);
        store.commit('SET_LOG_OF_MEMBER_WITH_AUTHORITY_DATA', payload);
      } else {
        alert('사람 잘못됨');
      }
    })
    .catch((err) => {
      console.log('err = ', err);
      const aaa = [
        {
          type: 'request',
          dt: '2021-10-28',
          time: '17:30:32',
          actor_name: '유현준',
          actor_id: 'STZ422',
          comment: '팀에 새로 합류 하였습니다.',
        },
        {
          type: 'agree',
          dt: '2021-10-28',
          time: '17:30:32',
          actor_name: '김승욱',
          actor_id: 'STZ434',
          comment: '권한 드립니다.',
        },
        {
          type: 'approve',
          dt: '2021-10-28',
          time: '17:30:32',
          actor_name: '이형주',
          actor_id: 'STZ286',
          comment: '최종 승인 합니다.',
        },
      ];
      store.commit('SET_LOG_OF_MEMBER_WITH_AUTHORITY_DATA', aaa);

      // const alarm = {
      //   method: messageMethod[3],
      //   title: 'Notification',
      //   message: '서버와의 통신 이상으로 사용자 정보를 가져오지 못하였습니다.',
      //   text: 'notification',
      //   type: messageTypes[3],
      //   params: JSON.stringify(params),
      //   function: 'getMemberAPI',
      //   content: err,
      // };
      // store.commit('SET_MESSAGE', alarm);
      // store.dispatch('SET_SLACK_ALARM', alarm);
    })
    .finally(() => {
      store.commit('SET_LOADING', false);
    });
};

const setMemberAffiliatedTeamRoleRequest = (store, state, url, params) => {
  // console.log('setMemberAffiliatedTeamRoleRequest (connector) =========================== ', url, params);
  store.commit('SET_LOADING', true);
  axios
    .get(url, {
      params,
    })
    .then((res) => {
      const payload = res.data.data;
      if (payload.success) {
        // store.commit('ADD_MEMBERS_DATA', payload);
        store.commit('EDIT_MEMBERS_DATA', payload.result);
      } else {
        alert('잘못됨');
      }
    })
    .catch((err) => {
      const alarm = {
        method: messageMethod[3],
        title: 'Notification',
        message: '서버와의 통신 이상으로 권한 요청을 하지 못하였습니다.',
        text: 'notification',
        type: messageTypes[3],
        params: JSON.stringify(params),
        function: 'setMemberAffiliatedTeamRoleRequest',
        content: err,
      };

      store.commit('SET_MESSAGE', alarm);
      store.dispatch('SET_SLACK_ALARM', alarm);
    })
    .finally(() => {
      store.commit('SET_LOADING', false);
    });
};

const setMemberAffiliatedTeamRoleRequestWithdrawAPI = (store, state, url, params) => {
  // console.log('setMemberAffiliatedTeamRoleRequestWithdrawAPI (connector) =========================== ', url, params);
  store.commit('SET_LOADING', true);
  axios
    .get(url, {
      params,
    })
    .then((res) => {
      const payload = res.data.data;

      if (payload.success) {
        // store.commit('ADD_MEMBERS_DATA', payload);
        store.commit('EDIT_MEMBERS_DATA', payload.result);
      } else {
        alert('잘못됨');
      }
    })
    .catch((err) => {
      const alarm = {
        method: messageMethod[3],
        title: 'Notification',
        message: '서버와의 통신 이상으로 철회 내용을 저장 하지 못하였습니다.',
        text: 'notification',
        type: messageTypes[3],
        params: JSON.stringify(params),
        function: 'setMemberAffiliatedTeamRoleRequestWithdrawAPI',
        content: err,
      };

      store.commit('SET_MESSAGE', alarm);
      store.dispatch('SET_SLACK_ALARM', alarm);
    })
    .finally(() => {
      store.commit('SET_LOADING', false);
    });
};

const setMemberAffiliatedTeamRoleRequestAgreeAPI = (store, state, url, params) => {
  // console.log('setMemberAffiliatedTeamRoleRequestAgreeAPI (connector) =========================== ', url, params);
  store.commit('SET_LOADING', true);
  axios
    .get(url, {
      params,
    })
    .then((res) => {
      const payload = res.data.data;

      if (payload.success) {
        store.commit('EDIT_MEMBERS_DATA', payload.result);
      } else {
        alert('잘못됨');
      }
    })
    .catch((err) => {
      const alarm = {
        method: messageMethod[3],
        title: 'Notification',
        message: '서버와의 통신 이상으로 합의내용을 저장 하지 못하였습니다.',
        text: 'notification',
        type: messageTypes[3],
        params: JSON.stringify(params),
        function: 'setMemberAffiliatedTeamRoleRequestAgreeAPI',
        content: err,
      };

      store.commit('SET_MESSAGE', alarm);
      store.dispatch('SET_SLACK_ALARM', alarm);
    })
    .finally(() => {
      store.commit('SET_LOADING', false);
    });
};

const setMemberAffiliatedTeamRoleRequestApproveAPI = (store, state, url, params) => {
  // console.log('setMemberAffiliatedTeamRoleRequestApproveAPI (connector) =========================== ', url, params);
  store.commit('SET_LOADING', true);
  axios
    .get(url, {
      params,
    })
    .then((res) => {
      const payload = res.data.data;

      if (payload.success) {
        store.commit('EDIT_MEMBERS_DATA', payload.result);
      } else {
        alert('잘못됨');
      }
    })
    .catch((err) => {
      const alarm = {
        method: messageMethod[3],
        title: 'Notification',
        message: '서버와의 통신 이상으로 결제정보를 저장 하지 못하였습니다.',
        text: 'notification',
        type: messageTypes[3],
        params: JSON.stringify(params),
        function: 'setMemberAffiliatedTeamRoleRequestApproveAPI',
        content: err,
      };

      store.commit('SET_MESSAGE', alarm);
      store.dispatch('SET_SLACK_ALARM', alarm);
    })
    .finally(() => {
      store.commit('SET_LOADING', false);
    });
};

const setEditMemberAPI = (store, state, url, params) => {
  // console.log('setEditMemberAPI (connector) =========================== ', url, params);
  store.commit('SET_LOADING', true);
  axios
    .get(url, {
      params,
    })
    .then((res) => {
      const payload = res.data.data;

      if (payload.success) {
        store.commit('EDIT_MEMBERS_DATA', params);
      } else {
        alert('잘못됨');
      }
    })
    .catch((err) => {
      const alarm = {
        method: messageMethod[3],
        title: 'Notification',
        message: '서버와의 통신 이상으로 설정을 저장 하지 못하였습니다.',
        text: 'notification',
        type: messageTypes[3],
        params: JSON.stringify(params),
        function: 'setEditMemberAPI',
        content: err,
      };

      store.commit('SET_MESSAGE', alarm);
      store.dispatch('SET_SLACK_ALARM', alarm);

      // -> todo: test code
      if (store.getters.base.env === 'development') {
        alarm.message = '개발모드이거나 BI팀 이라 강제로 member 정보를 넣어 준다.';
        alarm.type = messageTypes[0];

        store.commit('SET_MESSAGE', alarm);
        store.commit('EDIT_MEMBERS_DATA', params);
      }
      // <- todo: test code
    })
    .finally(() => {
      store.commit('SET_LOADING', false);
    });
};

const setCreateJobAPI = (store, state, url, params) => {
  // console.log('setCreateJobAPI (connector) =========================== ', store, state, url, params);
  axios
    .get(url, {
      params,
    })
    .then((res) => {
      const payload = res.data.data;

      if (payload.success) {
        store.commit('CREATE_JOBS_DATA', params);
      } else {
        alert('잘못됨');
      }
    })
    .catch((err) => {
      // -> todo: test code
      console.log('err = ', err);
      // <- todo: test code
    });
};

const setJobEditAPI = (store, state, url, params) => {
  // console.log('setJobEditAPI (connector) =========================== ', url, params);
  axios
    .get(url, {
      params,
    })
    .then((res) => {
      const payload = res.data.data;

      if (payload.success) {
        store.commit('EDIT_JOBS_DATA', params);
      } else {
        alert('잘못됨');
      }
    })
    .catch((err) => {
      // -> todo: test code
      console.log('err = ', err);
      // <- todo: test code
    });
};

const setJobRemoveAPI = (store, state, url, params) => {
  // console.log('setJobRemoveAPI (connector) =========================== ', url, params);
  axios
    .get(url, {
      params,
    })
    .then((res) => {
      const payload = res.data.data;

      if (payload.success) {
        store.commit('REMOVE_JOBS_DATA', params);
      } else {
        alert('잘못됨');
      }
    })
    .catch((err) => {
      // -> todo: test code
      console.log('err = ', err);
      // <- todo: test code
    });
};

const setTeamCreateAPI = (store, state, url, params) => {
  // console.log('setTeamCreateAPI (connector) =========================== ', store, state, url, params);
  axios
    .get(url, {
      params,
    })
    .then((res) => {
      console.log('res = ', res);
      const payload = res.data.data;

      if (payload.success) {
        store.commit('CREATE_TEAMS_DATA', params);
      } else {
        alert('잘못됨');
      }
    })
    .catch((err) => {
      // -> todo: test code
      console.log('err = ', err);
      // <- todo: test code
    });
};

const setTeamEditAPI = (store, state, url, params) => {
  // console.log('setTeamEditAPI (connector) =========================== ', store, state, url, params);
  axios
    .get(url, {
      params,
    })
    .then((res) => {
      const payload = res.data.data;

      if (payload.success) {
        store.commit('EDIT_TEAMS_DATA', params);
      } else {
        alert('잘못됨');
      }
    })
    .catch((err) => {
      // -> todo: test code
      console.log('err = ', err);
      // <- todo: test code
    });
};

const setTeamRemoveAPI = (store, state, url, params) => {
  // console.log('setTeamRemoveAPI (connector) =========================== ', url, params);
  axios
    .get(url, {
      params,
    })
    .then((res) => {
      const payload = res.data.data;

      if (payload.success) {
        store.commit('REMOVE_TEAMS_DATA', params);
      } else {
        alert('잘못됨');
      }
    })
    .catch((err) => {
      // -> todo: test code
      console.log('err = ', err);
      // <- todo: test code
    });
};

const setAddMemberToTeamAPI = (store, state, url, params) => {
  // console.log('setAddMemberToTeamAPI (connector) =========================== ', url, params);
  axios
    .get(url, {
      params,
    })
    .then((res) => {
      const payload = res.data.data;

      if (payload.success) {
        store.commit('ADD_MEMBERS_DATA', params);
      } else {
        alert('잘못됨');
      }
    })
    .catch((err) => {
      // -> todo: test code
      console.log('err = ', err);
      // <- todo: test code
    });
};

const setSlackAlarmAPI = (store, url, params) => {
  axios
    .get(url, {
      params,
    })
    .then((res) => {
      console.log('SET_SLACK_ALARM = ', res);
    })
    .catch((err) => {
      console.log(`==== SET_SLACK_ALARM, ${err} ===`);
    });
};

export default {
  getLoginUserAIP,
  getConfigAPI,
  getMemberAPI,
  getMembersWithAuthorityAPI,
  getLogOfMemberWithAuthorityAPI,
  //
  setEditMemberAPI,
  setMemberAffiliatedTeamRoleRequest,
  setMemberAffiliatedTeamRoleRequestWithdrawAPI,
  setMemberAffiliatedTeamRoleRequestAgreeAPI,
  setMemberAffiliatedTeamRoleRequestApproveAPI,

  setCreateJobAPI,
  setJobEditAPI,
  setJobRemoveAPI,

  setTeamCreateAPI,
  setTeamEditAPI,
  setTeamRemoveAPI,
  setAddMemberToTeamAPI,
  //
  setSlackAlarmAPI,
};




// WEBPACK FOOTER //
// ./src/store/util/connector.js